import { GetOrganizationsListResponseBodyType } from "@intelligems/ig-types";
import { orgListKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";

export const getOrgList = async () => {
  const resp = await api.get<GetOrganizationsListResponseBodyType>(
    `/v2/organizations-list`
  );
  return resp.data;
};

export const useGetOrgList = () => {
  return useQuery<GetOrganizationsListResponseBodyType, Error>({
    queryKey: orgListKeys.all,
    queryFn: async () => getOrgList(),
  });
};
